import React, { useState } from 'react';

const LazyImage = ({
    src,
    alt,
    className = "",
    placeholderClassName = "bg-gray-200 animate-pulse",
    onLoad,
    onError,
    ...props
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const handleLoad = () => {
        setIsLoading(false);
        if (onLoad) onLoad();
    };

    const handleError = () => {
        setIsLoading(false);
        setHasError(true);
        if (onError) onError();
    };

    return (
        <div className={`relative ${className}`}>
            {/* Loading placeholder */}
            {isLoading && (
                <div className={`absolute inset-0 ${placeholderClassName}`} />
            )}

            {/* Error placeholder */}
            {hasError && (
                <div className="absolute inset-0 bg-gray-300 flex items-center justify-center">
                    <div className="text-gray-500 text-sm">Bild nicht verfügbar</div>
                </div>
            )}

            {/* Actual image */}
            <img
                src={src}
                alt={alt}
                className={`${className} ${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
                onLoad={handleLoad}
                onError={handleError}
                loading="lazy"
                {...props}
            />
        </div>
    );
};

export default LazyImage; 